let snackbarCallback = null;

export const showSnackbar = (message, severity = "success") => {
  if (snackbarCallback) {
    // Ensure Snackbar resets before showing again
    snackbarCallback({ open: false, message: "", severity });

    // Small delay to re-trigger state update
    setTimeout(() => {
      snackbarCallback({ open: true, message, severity });
    }, 100);
  }
};

export const setSnackbarCallback = (callback) => {
  snackbarCallback = callback;
};
